import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';

const TestimoniulAdd = () => {
    const navigate = useNavigate();
    const { http } = ProtectAPi();

    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [review, setReview] = useState('');
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [loader, setLoader] = useState('off');

    const [nameError, setNameError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [reviewError, setReviewError] = useState('');

    const submitForm = () => {
        setLoader('on');
        const formData = new FormData();
        formData.append('name', name);
        formData.append('title', title);
        formData.append('review', review);
        formData.append('image', image);

        http.post('/store-testimoniul', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                setLoader('off');
                const errors = res.data.error;
                setNameError(errors.name ? errors.name[0] : '');
                setTitleError(errors.title ? errors.title[0] : '');
                setReviewError(errors.review ? errors.review[0] : '');
            } else {
                navigate('/admin/pages/home/testimoniul-list');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    return (
        <div className="main-content">
            <section className="section userr">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <h5>Add New Testimonial</h5>
                                        <BackButton />
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4 text-center">
                                            <label htmlFor="userImage">
                                                <div className="image-box border dottet p-2 rounded mx-auto" style={{ width: '250px', height: '250px', overflow: 'hidden' }}>
                                                    {imagePreview ? (
                                                        <img src={imagePreview} className='img-fluid' alt="Preview" />
                                                    ) : (
                                                        <img src="https://www.shareicon.net/data/512x512/2016/05/24/770137_man_512x512.png" className='img-fluid' style={{ width: '230px', height: '230px' }} alt="Default" />
                                                    )}
                                                </div>
                                                <input type="file" id="userImage" className="form-control d-none" onChange={handleImageChange} />
                                                <span className="btn btn-primary mt-2 w-100">Upload Image</span>
                                            </label>
                                        </div>

                                        <div className="col-md-8">
                                            <div className="form-group mb-3">
                                                <label>Name</label>
                                                <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                                                <span className="text-danger">{nameError}</span>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Title</label>
                                                <input type="text" className="form-control" value={title} onChange={e => setTitle(e.target.value)} />
                                                <span className="text-danger">{titleError}</span>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Review</label>
                                                <textarea className="form-control" rows="5" value={review} onChange={e => setReview(e.target.value)}></textarea>
                                                <span className="text-danger">{reviewError}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        {loader === 'off' ? (
                                            <button type="submit" onClick={submitForm} className="btn btn-primary btn-lg">Create</button>
                                        ) : (
                                            <div className="spinner-border text-dark" role="status"></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TestimoniulAdd;
